// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"aafa2e60","436":"3c9482f2","571":"64dea2ac"}[chunkId] + ".chunk.css";
};